import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { Subscription } from 'rxjs';
import { LottosService } from '../../services/lottos/lottos.service';
import { trigger, style, animate, transition } from '@angular/animations';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-fixed-box',
  templateUrl: './fixed-box.component' + AuthService.multisite.view + '.html',
  styleUrls: ['./fixed-box.component.scss'],
  animations: [
    trigger('isShow', [
      transition(':enter', [
        style({
          transform: 'scaleY(0)',
          opacity: 0
        }),
        animate(
          '.35s ease-in',
          style({
            transform: 'scaleY(1)',
            opacity: 1
          })
        )
      ]),
      transition(':leave', [
        style({
          transform: 'scaleY(1)',
          opacity: 1
        }),
        animate(
          '.35s ease-out',
          style({
            transform: 'scaleY(0)',
            opacity: 0
          })
        )
      ])
    ])
  ]
})
export class FixedBoxComponent implements OnInit {
  @Input() boxShow: boolean = false;
  public lottoId = environment.lottery.lot_id;
  public name: string;
  public country: string;
  public jackpot: number;
  public sys: string;
  public currency: string;
  public product: string;
  public prodId: number;
  public baseUrl: string = 'https://d3tmfelegj51yl.cloudfront.net/lotto-logos/';
  public subs: Subscription;

  constructor(private _lotto: LottosService) {}

  ngOnInit(): void {
    this.setJackpot();
  }

  setJackpot(): void {
    this.subs = this._lotto.lottoObservable$.subscribe((lottoObj) => {
      this.country = lottoObj['country'];
      this.name = this.lottoId === 11 ? 'Mega Da Virada' : lottoObj['name'];
      this.jackpot = lottoObj['jackpot'];
      this.currency = lottoObj['currency'];
      this.sys = lottoObj['system'];
      this.prodId = lottoObj['id'];
      this.product = lottoObj['product'];
    });
  }

  get bgColor() {
    return `bg-product-${this.prodId}`;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
